import React from 'react';

import LoadingSpinner, {
  SIZES as SPINNER_SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import FileTextIcon from '@buyside/svgs/file_text.svg';

import styles from '@buyside/components/presentation/Dropzone/dropzoneInputStyles.scss';

const DropzoneFile: React.FC<{
  filename: string;
  loading: boolean;
  open: () => void;
  onRemove?: () => void;
}> = ({ filename, open, loading, onRemove }): React.ReactElement => {
  return (
    <div className={styles.dropzoneFile}>
      <div className={styles.dropzoneFileInfo}>
        <span className={styles.dropzoneFileIcon}>
          {loading ? <LoadingSpinner size={SPINNER_SIZES.NANO} /> : <FileTextIcon />}
        </span>
        <span>{filename}</span>
      </div>
      <div className={styles.dropzoneFileButtons}>
        {onRemove && (
          <Button
            buttonType={BUTTON_TYPES.BUTTON}
            id="dropzone-remove-file"
            isLoading={loading}
            onClick={onRemove}
            size={BUTTON_SIZES.TINIEST}
            text="Remove"
            type={BUTTON_TYPES.DANGER}
          />
        )}
        <Button
          buttonType={BUTTON_TYPES.BUTTON}
          isLoading={loading}
          onClick={open}
          size={BUTTON_SIZES.TINIEST}
          text="Change"
          type={BUTTON_TYPES.PRIMARY}
        />
      </div>
    </div>
  );
};

export default DropzoneFile;
